import { Alert, AlertDescription, AlertTitle } from "ui/components/alert";
import React, { useEffect, useState } from "react";
import { Tabs, TabsList, TabsTrigger } from "ui/components/tabs";

import { CIRCLE_ALERT } from "icons/src";
import { Icon } from "components/index";
import { Shimmer } from "components/shimmer";
import { useStatuses } from "hooks/src/useStatuses";

export const StatusTabInput = ({
  collection,
  value,
  onChange,
  remove = [],
  disabled,
  sort,
}) => {
  const [status, setStatus] = useState(null);

  const { data, isLoading, isError } = useStatuses({
    collection: collection,
    remove,
    sort,
  });

  useEffect(() => {
    if (value) {
      setStatus(value);
    }
  }, [value]);

  function handleChange(value) {
    setStatus(value);
    onChange?.(value);
  }

  if (isLoading) {
    return (
      <div>
        <div className="flex space-x-2">
          {Array.from({ length: 4 }).map((_, i) => (
            <Shimmer key={i} className="h-8 w-24 rounded-md" />
          ))}
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <Alert variant="destructive">
        <Icon icon={CIRCLE_ALERT} className="size-4" />
        <AlertTitle>Error loading statuses</AlertTitle>
        <AlertDescription>Please try again.</AlertDescription>
      </Alert>
    );
  }

  return (
    <Tabs
      value={status}
      onValueChange={(value) => handleChange(value)}
      disabled={disabled}
    >
      <TabsList className="bg-muted w-full">
        {data.map((status) => (
          <TabsTrigger
            key={status.value}
            value={status.value}
            className="cursor-pointer"
            disabled={disabled}
          >
            {status.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};
